import React, { useEffect, useRef, useState } from 'react';

const ScrollAnimation = ({ children, className = '', animation = 'fade-up', delay = 0 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const domRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // Optional: Stop observing once visible to prevent re-triggering
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    const currentRef = domRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  const getAnimationClass = () => {
    if (!isVisible) {
      switch (animation) {
        case 'fade-up': return 'opacity-0 translate-y-10';
        case 'fade-in': return 'opacity-0';
        case 'fade-left': return 'opacity-0 -translate-x-10';
        case 'fade-right': return 'opacity-0 translate-x-10';
        default: return 'opacity-0 translate-y-10';
      }
    }
    return 'opacity-100 translate-x-0 translate-y-0';
  };

  const transitionDelay = { transitionDelay: `${delay}ms` };

  return (
    <div
      ref={domRef}
      className={`transition-all duration-1000 ease-out ${getAnimationClass()} ${className}`}
      style={transitionDelay}
    >
      {children}
    </div>
  );
};

export default ScrollAnimation;
